<template>
  <el-dialog
    title="后台报名"
    :visible.sync="formVisible"
    width="1000px"
    :close-on-click-modal="false"
    :style="{ marginTop: '0' }"
    @close="onMainDialogClose"
  >
    <el-form
      ref="dataForm"
      :rules="formRules"
      :model="form"
      label-position="right"
      size="small"
      label-width="140px"
    >
      <!-- 报名会议部分 -->
      <div class="form-section">
        <div class="section-title">报名会议</div>
        <el-form-item label="报名会议：" prop="meetingId">
          <el-select
            v-model="form.meetingId"
            placeholder="请选择需要报名的会议"
            clearable
            filterable
            size="small"
            @change="changeMeeting"
          >
            <el-option
              v-for="(item, index) in options.meetingOptions"
              :key="index"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
          <div
            class="meeting-info-grid"
            v-if="selectedMeeting && selectedMeeting.categoryName"
          >
            <div class="meeting-info-item">
              <span class="meeting-info-label">会议类型：</span>
              <span class="meeting-info-value">{{
                selectedMeeting.categoryName
              }}</span>
            </div>
            <div
              class="meeting-info-item"
              v-if="selectedMeeting && selectedMeeting.lecturerRealName"
            >
              <span class="meeting-info-label">主讲老师：</span>
              <span class="meeting-info-value">{{
                selectedMeeting.lecturerRealName
              }}</span>
            </div>
            <div
              class="meeting-info-item"
              v-if="
                selectedMeeting &&
                  selectedMeeting.startTime &&
                  selectedMeeting.endTime
              "
            >
              <span class="meeting-info-label">会议时间：</span>
              <span class="meeting-info-value">{{
                formatMeetingTime(
                  selectedMeeting.startTime,
                  selectedMeeting.endTime
                )
              }}</span>
            </div>

            <div class="meeting-info-item" v-if="address">
              <span class="meeting-info-label">地址：</span>
              <span class="meeting-info-value">{{ address }}</span>
            </div>
          </div>
        </el-form-item>
      </div>
      <!-- 报名人身份和账号选择 -->
      <div class="form-section">
        <div class="section-title">报名人信息</div>
        <el-row :gutter="20" class="form-row-spacing">
          <el-col :span="12">
            <el-form-item label="报名人身份：" prop="identityId">
              <el-select
                v-model="form.identityId"
                placeholder="请选择类型/研修班"
                clearable
                size="small"
                :disabled="!form.meetingId"
                @change="changeIdentity"
              >
                <el-option
                  v-for="item in identityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.level"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名人账号：" prop="userId">
              <el-select
                v-model="form.userId"
                placeholder="请选择报名人账号"
                remote
                :remote-method="searchUsers"
                :loading="loading"
                filterable
                clearable
                size="small"
                :disabled="!form.identityId"
                @change="changeUser"
              >
                <el-option
                  v-for="(item, index) in selectOptions"
                  :key="index"
                  :label="item.value"
                  :value="item.userId"
                ></el-option>
              </el-select>
              <div v-if="!selectedUserHasFaceInfo" class="face-info-warning">
                还未人脸认证，不支持本人参会
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 报名信息部分 - 只有选择了报名人账号后才显示 -->
      <div v-if="form.userId" class="form-section">
        <div class="section-title">报名信息</div>
        <el-form-item label="报名信息：" prop="registrantList">
          <!-- 只有 level 6 和 7 的身份可以添加多个参会人，其他身份只能自己报名 -->
          <el-button
            v-if="canAddMultipleRegistrants"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="openSelectRegistrantDialog"
            >添加参会人</el-button
          >
        </el-form-item>
        <div
          v-if="form.registrantList && form.registrantList.length > 0"
          class="registrant-table-container"
        >
          <!-- 表头 -->
          <div class="table-header">
            <div class="table-cell">姓名</div>
            <div class="table-cell">性别</div>
            <div class="table-cell">与报名者关系</div>
            <div class="table-cell id-card-cell">身份证号码</div>
            <div class="table-cell">手机号码</div>
            <div class="table-cell">操作</div>
          </div>
          <!-- 表格内容 -->
          <div class="table-body">
            <div
              v-for="(registrant, index) in form.registrantList"
              :key="index"
              class="table-row-wrapper"
            >
              <!-- 主参会人行 -->
              <div class="table-row parent-row">
                <div class="table-cell">
                  <span>{{ registrant.realName }}</span>
                </div>
                <div class="table-cell">
                  {{
                    registrant.sex === 1
                      ? "男"
                      : registrant.sex === 2
                      ? "女"
                      : ""
                  }}
                </div>
                <div class="table-cell">{{ registrant.relationship }}</div>
                <div class="table-cell id-card-cell">
                  <span class="id-card-number">{{ registrant.idCardNo }}</span>
                  <span class="age-tag">(成人)</span>
                </div>
                <div class="table-cell">
                  {{ registrant.mobile }}
                </div>
                <div class="table-cell">
                  <el-button
                    type="text"
                    size="small"
                    @click="removeRegistrant(registrant, index)"
                    >移除</el-button
                  >
                  <el-button
                    v-if="
                      selectedMeeting && selectedMeeting.maxCarryChildPer > 0
                    "
                    type="text"
                    size="small"
                    @click="showAddChildDialog(registrant)"
                    >携带儿童</el-button
                  >
                </div>
              </div>
              <!-- 儿童行 -->
              <div
                v-if="registrant.child && registrant.child.length > 0"
                class="child-rows-wrapper"
              >
                <div
                  v-for="(child, childIndex) in registrant.child"
                  :key="childIndex"
                  class="table-row child-row"
                >
                  <div class="table-cell">
                    <span>
                      {{
                        child.relationship
                          ? `${child.realName} (${child.relationship})`
                          : child.realName
                      }}
                    </span>
                  </div>
                  <div class="table-cell">
                    {{ child.sex === 1 ? "男" : child.sex === 2 ? "女" : "" }}
                  </div>
                  <div class="table-cell id-card-cell">
                    <span>{{ child.idCardNo }}</span>
                    <span class="age-tag">(儿童)</span>
                  </div>
                  <div class="table-cell">{{ formatMobile(child.mobile) }}</div>
                  <div class="table-cell">
                    <el-button
                      type="text"
                      size="small"
                      @click="removeChild(index, childIndex)"
                      >移除</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--会议报名费用-->
      <div
        class="form-section"
        v-if="
          selectedMeeting &&
            form.registrantList &&
            form.registrantList.length > 0
        "
      >
        <div class="section-title">会议报名费用</div>
        <div class="fee-display">
          <div
            v-if="
              !selectedMeeting.feeList || selectedMeeting.feeList.length === 0
            "
            class="free-text"
          >
            免费
          </div>
          <div v-else class="fee-info">
            <div class="fee-detail">
              <span class="fee-label">应支付金额：</span>
              <span class="fee-amount"
                >¥{{ calculatedTotalFee.toFixed(2) }}</span
              >
            </div>
            <div class="fee-breakdown" v-if="feeBreakdown.length > 0">
              <div
                class="breakdown-item"
                v-for="(item, index) in feeBreakdown"
                :key="index"
              >
                <span>{{ item.label }}：</span>
                <span
                  >¥{{ item.amount.toFixed(2) }} × {{ item.count }} = ¥{{
                    item.total.toFixed(2)
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 线下支付部分 -->
      <div class="form-section" v-if="!isFreeMeeting">
        <div class="section-title">线下支付</div>
        <el-form-item label="报名金额：" prop="payVouchersFee" class="gap-22">
          <el-input
            v-model="form.payVouchersFee"
            type="number"
            placeholder="请输入报名金额"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item
          label="付款凭证："
          prop="payVouchers"
          required
          class="gap-22"
        >
          <div class="upload-wrapper">
            <el-upload
              :action="uploadImgUrl"
              list-type="picture-card"
              :file-list="payVoucherList"
              :on-success="handlePayVoucherUpload"
              :on-remove="handlePayVoucherRemove"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="upload-hint">支持上传多张</span>
          </div>
        </el-form-item>
        <el-form-item label="申请凭证：">
          <div class="upload-wrapper">
            <el-upload
              :action="uploadImgUrl"
              list-type="picture-card"
              :file-list="applyVoucherList"
              :on-success="handleApplyVoucherUpload"
              :on-remove="handleApplyVoucherRemove"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="upload-hint">支持上传多张</span>
          </div>
        </el-form-item>
      </div>
    </el-form>

    <!-- 选择报名人弹窗 -->
    <select-registrant-dialog
      :visible.sync="selectDialogVisible"
      :meeting-id="form.meetingId"
      :user-id="form.userId"
      :user-info-id="form.userInfoId"
      :user-type="form.userType"
      :phone="phone"
      :existing-registrants="form.registrantList"
      :max-carry-people="selectedMeeting.maxCarryPeople"
      @confirm="handleSelectRegistrantsConfirm"
      @close="onSelectDialogClose"
    />

    <!-- 选择儿童弹窗 -->
    <select-child-dialog
      :visible.sync="childDialogVisible"
      :meeting-id="form.meetingId"
      :user-id="form.userId"
      :user-info-id="form.userInfoId"
      :user-type="form.userType"
      :max-carry-child-per="
        selectedMeeting ? selectedMeeting.maxCarryChildPer : 0
      "
      :existing-children="
        currentParentRegistrant && currentParentRegistrant.child
          ? currentParentRegistrant.child
          : []
      "
      @confirm="handleSelectChildrenConfirm"
      @close="onChildDialogClose"
    />

    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消 </el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import meetingApi from "@/api/meeting/meeting";
import technicianInfoApi from "@/api/technical/technicianInfo";
import customerApi from "@/api/technical/customer";
import userApi from "@/api/sys/user";
import meetingCarryPeopleApi from "@/api/meeting/meetingCarryPeople";
import SelectRegistrantDialog from "./SelectRegistrantDialog.vue";
import SelectChildDialog from "./SelectChildDialog.vue";
function initFormBean() {
  const formBean = {
    meetingId: null,
    identityId: null, // 报名人类型（身份ID）
    userType: null,
    userId: null,
    userInfoId: null,
    registrantList: [], // 报名人列表
    fee: null,
    payVouchersFee: null, // 报名金额
    payVouchers: [], // 付款凭证URL数组
    applyVouchers: [] // 申请凭证URL数组
  };
  return formBean;
}

export default {
  components: {
    SelectRegistrantDialog,
    SelectChildDialog
  },
  data() {
    return {
      old: initFormBean(),
      form: initFormBean(),
      formVisible: false,
      formRules: {
        meetingId: [
          { required: true, message: "请选择需要报名的会议", trigger: "change" }
        ],
        userType: [
          { required: true, message: "请选择报名人员类型", trigger: "change" }
        ],
        identityId: [
          { required: true, message: "请选择报名人身份", trigger: "change" }
        ],
        userId: [
          { required: true, message: "请选择报名人员", trigger: "change" }
        ],
        registrantList: [
          { required: true, message: "请选择参会人员", trigger: "change" }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        payVouchers: [
          {
            required: true,
            message: "请上传付款凭证",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (
                !this.form.payVouchers ||
                this.form.payVouchers.length === 0
              ) {
                callback(new Error("请上传付款凭证"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      options: {
        identityOptions: [],
        customerOptions: [],
        customerKFOptions: [],
        meetingOptions: [],
        usersOptions: []
      },
      identityList: [], // 身份列表（体验班/研修班等）- 根据会议筛选后的
      allIdentityList: [], // 完整的身份列表（用于筛选）
      selectOptions: [],
      phone: "",
      selectedUserHasFaceInfo: true, // 当前选中用户是否有人脸认证信息
      address: "",
      isRepSub: false,
      searchVal: "",
      loading: false,
      selectedMeeting: {}, // 保存选中的会议详细信息
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload", // 上传图片地址
      payVoucherList: [], // 付款凭证文件列表
      applyVoucherList: [], // 申请凭证文件列表
      showAddRegistrantDialog: false, // 旧字段，后续删除
      selectDialogVisible: false,
      registrantCandidates: [],
      selectedCandidateRows: [],
      // 儿童选择
      childDialogVisible: false,
      childCandidates: [],
      selectedChildRows: [],
      currentParentRegistrant: null,
      // 新增/编辑报名人表单（通用，用于成人和儿童）
      personFormDialogVisible: false,
      personFormDialogTitle: "新建报名人",
      personForm: {
        realName: "",
        sex: null,
        relationship: "",
        idCardNo: "",
        mobile: "",
        isChild: false
      },
      editingPersonIndex: null, // 编辑时保存的索引
      editingPersonList: null // 编辑时保存的列表引用（registrantCandidates 或 childCandidates）
    };
  },
  computed: {
    // 判断是否可以添加多个参会人（level 6 和 7 可以多行）
    canAddMultipleRegistrants() {
      if (!this.form.identityId) {
        return false;
      }
      // level 6 和 7 可以添加多个参会人
      const multiRowLevels = [6, 7];
      return multiRowLevels.includes(this.form.identityId);
    },
    // 判断会议是否免费
    isFreeMeeting() {
      // 如果费用列表为空或长度为0，则为免费
      if (
        !this.selectedMeeting ||
        !this.selectedMeeting.feeList ||
        this.selectedMeeting.feeList.length === 0
      ) {
        return true;
      }
      return false;
    },
    // 计算会议报名费用
    calculatedTotalFee() {
      // 如果费用列表为空，返回0（显示免费）
      if (
        !this.selectedMeeting ||
        !this.selectedMeeting.feeList ||
        this.selectedMeeting.feeList.length === 0
      ) {
        return 0;
      }

      // 如果没有选择身份或没有参会人，返回0
      if (
        !this.form.identityId ||
        !this.form.registrantList ||
        this.form.registrantList.length === 0
      ) {
        return 0;
      }

      let totalFee = 0;

      // 计算成人数量
      const adultCount = this.form.registrantList.length;

      // 计算儿童数量
      let childCount = 0;
      this.form.registrantList.forEach(registrant => {
        if (registrant.child && Array.isArray(registrant.child)) {
          childCount += registrant.child.length;
        }
      });

      // 根据身份匹配成人费用
      if (adultCount > 0) {
        const adultFee = this.selectedMeeting.feeList.find(fee => {
          // 匹配 levelId 或 type
          return (
            fee.levelId === this.form.identityId ||
            (fee.type === 20 && fee.levelId === this.form.identityId) ||
            (this.form.identityId === 30 && fee.type === 30) ||
            (this.form.identityId === 10 && fee.type === 10)
          );
        });

        if (
          adultFee &&
          adultFee.amount !== null &&
          adultFee.amount !== undefined
        ) {
          const feeAmount = parseFloat(adultFee.amount) || 0;
          totalFee += feeAmount * adultCount;
        }
      }

      // 根据身份匹配儿童费用
      if (childCount > 0) {
        const childFee = this.selectedMeeting.feeList.find(fee => {
          // 儿童票：type === 100 或 type === 70
          return fee.type === 100 || fee.type === 70;
        });

        if (
          childFee &&
          childFee.amount !== null &&
          childFee.amount !== undefined
        ) {
          const feeAmount = parseFloat(childFee.amount) || 0;
          totalFee += feeAmount * childCount;
        }
      }

      return totalFee;
    },
    // 费用明细
    feeBreakdown() {
      const breakdown = [];

      // 如果费用列表为空，返回空数组
      if (
        !this.selectedMeeting ||
        !this.selectedMeeting.feeList ||
        this.selectedMeeting.feeList.length === 0
      ) {
        return breakdown;
      }

      // 如果没有选择身份或没有参会人，返回空数组
      if (
        !this.form.identityId ||
        !this.form.registrantList ||
        this.form.registrantList.length === 0
      ) {
        return breakdown;
      }

      // 计算成人数量
      const adultCount = this.form.registrantList.length;

      // 计算儿童数量
      let childCount = 0;
      this.form.registrantList.forEach(registrant => {
        if (registrant.child && Array.isArray(registrant.child)) {
          childCount += registrant.child.length;
        }
      });

      // 获取身份名称
      const identity = this.identityList.find(
        item =>
          item.level === this.form.identityId ||
          item.id === this.form.identityId
      );
      const identityName = identity ? identity.name : "成人";

      // 根据身份匹配成人费用
      if (adultCount > 0) {
        const adultFee = this.selectedMeeting.feeList.find(fee => {
          return (
            fee.levelId === this.form.identityId ||
            (fee.type === 20 && fee.levelId === this.form.identityId) ||
            (this.form.identityId === 30 && fee.type === 30) ||
            (this.form.identityId === 10 && fee.type === 10)
          );
        });

        if (
          adultFee &&
          adultFee.amount !== null &&
          adultFee.amount !== undefined
        ) {
          const feeAmount = parseFloat(adultFee.amount) || 0;
          if (feeAmount > 0) {
            breakdown.push({
              label: identityName,
              amount: feeAmount,
              count: adultCount,
              total: feeAmount * adultCount
            });
          }
        }
      }

      // 根据身份匹配儿童费用
      if (childCount > 0) {
        const childFee = this.selectedMeeting.feeList.find(fee => {
          return fee.type === 100 || fee.type === 70;
        });

        if (
          childFee &&
          childFee.amount !== null &&
          childFee.amount !== undefined
        ) {
          const feeAmount = parseFloat(childFee.amount) || 0;
          if (feeAmount > 0) {
            breakdown.push({
              label: "儿童",
              amount: feeAmount,
              count: childCount,
              total: feeAmount * childCount
            });
          }
        }
      }

      return breakdown;
    },
    // 扁平化报名人列表，将儿童嵌套显示在大人下面
    flattenedRegistrantList() {
      if (
        !this.form.registrantList ||
        !Array.isArray(this.form.registrantList)
      ) {
        return [];
      }
      const result = [];
      this.form.registrantList.forEach((parent, parentIndex) => {
        // 添加大人（成人）
        const parentWithKey = {
          ...parent,
          uniqueKey: `parent_${parentIndex}`,
          isChild: false,
          parentIndex: parentIndex
        };
        result.push(parentWithKey);

        // 添加该大人的儿童
        if (
          parent.child &&
          Array.isArray(parent.child) &&
          parent.child.length > 0
        ) {
          parent.child.forEach((child, childIndex) => {
            const childWithKey = {
              ...child,
              uniqueKey: `parent_${parentIndex}_child_${childIndex}`,
              isChild: true,
              parentIndex: parentIndex,
              childIndex: childIndex
            };
            result.push(childWithKey);
          });
        }
      });
      return result;
    },
    personFormRules() {
      return {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        relationship: [
          { required: true, message: "请输入报名者关系", trigger: "blur" }
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
      };
    }
  },
  created() {
    this.loadIdentityList();
  },
  methods: {
    // 打开选择报名人弹窗（组件内部会处理数据加载）
    openSelectRegistrantDialog() {
      this.selectDialogVisible = true;
    },
    // 生成候选报名人（后端已返回"本人"数据，不需要前端创建）
    buildRegistrantCandidates() {
      const candidates = [];
      // 将已存在的报名人也并入（避免重复选择时看见已有数据）
      (this.form.registrantList || []).forEach(item => {
        candidates.push({ ...item });
      });
      this.registrantCandidates = candidates;
    },
    // 候选表格多选回调
    handleCandidateSelectionChange(rows) {
      this.selectedCandidateRows = rows;
    },
    // 打开新增报名人弹窗（成人）
    openAddPersonDialog() {
      this.personFormDialogTitle = "新建报名人";
      this.editingPersonIndex = null;
      this.editingPersonList = this.registrantCandidates;
      this.resetPersonForm();
      this.personForm.isChild = false;
      this.personFormDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.personForm) {
          this.$refs.personForm.clearValidate();
        }
      });
    },
    // 打开编辑报名人弹窗（成人）
    openEditPersonDialog(index) {
      this.personFormDialogTitle = "编辑报名人";
      this.editingPersonIndex = index;
      this.editingPersonList = this.registrantCandidates;
      const person = this.registrantCandidates[index];
      this.personForm = {
        realName: person.realName || "",
        sex: person.sex || null,
        relationship: person.relationship || "",
        idCardNo: person.idCardNo || "",
        mobile: person.mobile || "",
        isChild: person.isChild || false
      };
      this.personFormDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.personForm) {
          this.$refs.personForm.clearValidate();
        }
      });
    },
    // 打开新增儿童弹窗
    openAddChildPersonDialog() {
      this.personFormDialogTitle = "新建参会儿童";
      this.editingPersonIndex = null;
      this.editingPersonList = this.childCandidates;
      this.resetPersonForm();
      this.personForm.isChild = true;
      this.personFormDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.personForm) {
          this.$refs.personForm.clearValidate();
        }
      });
    },
    // 打开编辑儿童弹窗
    openEditChildPersonDialog(index) {
      this.personFormDialogTitle = "编辑参会儿童";
      this.editingPersonIndex = index;
      this.editingPersonList = this.childCandidates;
      const person = this.childCandidates[index];
      this.personForm = {
        realName: person.realName || "",
        sex: person.sex || null,
        relationship: person.relationship || "",
        idCardNo: person.idCardNo || "",
        mobile: person.mobile || "",
        isChild: true
      };
      this.personFormDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.personForm) {
          this.$refs.personForm.clearValidate();
        }
      });
    },
    // 重置报名人表单
    resetPersonForm() {
      this.personForm = {
        realName: "",
        sex: null,
        relationship: "",
        idCardNo: "",
        mobile: "",
        isChild: false
      };
    },
    // 关闭报名人表单弹窗
    onPersonFormDialogClose() {
      this.resetPersonForm();
      this.editingPersonIndex = null;
      this.editingPersonList = null;
      if (this.$refs.personForm) {
        this.$refs.personForm.clearValidate();
      }
    },
    // 确认保存报名人表单（通用，支持成人和儿童）
    confirmPersonForm() {
      this.$refs.personForm.validate(valid => {
        if (valid) {
          const personData = {
            ...this.personForm,
            userId: null,
            userInfoId: null,
            userType: null
          };
          // 使用保存的列表引用（registrantCandidates 或 childCandidates）
          const targetList =
            this.editingPersonList || this.registrantCandidates;
          if (this.editingPersonIndex !== null) {
            // 编辑模式：更新现有数据
            this.$set(targetList, this.editingPersonIndex, personData);
          } else {
            // 新增模式：添加到列表
            targetList.push(personData);
          }
          this.personFormDialogVisible = false;
        }
      });
    },
    // 确认选择，合并到报名人列表
    // 处理选择报名人确认事件（来自组件，此时已经保存成功）
    handleSelectRegistrantsConfirm(selectedRows) {
      if (!Array.isArray(this.form.registrantList)) {
        this.$set(this.form, "registrantList", []);
      }
      const exists = this.form.registrantList;
      const selected = selectedRows || [];

      // 合并到列表（去重）
      selected.forEach(item => {
        // 初始化展开状态
        if (!item.isExpanded) {
          this.$set(item, "isExpanded", true);
        }
        // 简单去重：按姓名+手机号+身份证号
        const dup = exists.find(
          it =>
            it.realName === item.realName &&
            it.mobile === item.mobile &&
            it.idCardNo === item.idCardNo
        );

        if (!dup) {
          // 确保每个报名人都有 child 数组
          const newItem = { ...item };
          if (!newItem.child) {
            newItem.child = [];
          }
          exists.push(newItem);
        }
      });

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate("registrantList");
        }
      });
    },
    // 加载身份列表
    loadIdentityList() {
      try {
        const levelList = JSON.parse(localStorage.getItem("levelList")) || [];
        this.allIdentityList = levelList.map(level => ({
          id: level.id,
          name: level.name,
          level: level.level,
          userType: 20 //业务线
        }));

        // 添加技术老师
        this.allIdentityList.push({
          id: 99,
          name: "技术老师",
          level: 99,
          userType: 30
        });

        // 添加内部员工
        this.allIdentityList.push({
          id: 101,
          name: "内部员工",
          level: 101,
          userType: 10
        });
       

      
      
          // 初始显示所有身份
        this.identityList = [...this.allIdentityList];

        
      } catch (error) {
        console.error("加载身份列表失败:", error);
        this.allIdentityList = [];
        this.identityList = [];
      }
    },
    // 根据会议费用列表筛选身份
    filterIdentityListByMeeting(meeting) {
     

      if (!meeting || !meeting.feeList || !Array.isArray(meeting.feeList)) {
        // 如果没有会议或费用列表，显示所有身份
        this.identityList = [...this.allIdentityList];
        return;
      }

      // 从费用列表中提取所有可用的 levelId
      // 过滤掉金额是-1和null的数据，金额是-1或者null的表示没有配置免费或者收费，就不允许报名
      const availableLevelIds = new Set();
      meeting.feeList.forEach(fee => {
        // 检查费用项是否有效：至少有一个金额字段不是 -1 或 null
        const hasValidAmount =
          (fee.amount !== null &&
            fee.amount !== undefined &&
            fee.amount !== -1) ||
          (fee.balance !== null &&
            fee.balance !== undefined &&
            fee.balance !== -1) ||
          (fee.xiaoduCoin !== null &&
            fee.xiaoduCoin !== undefined &&
            fee.xiaoduCoin !== -1) ||
          (fee.tuition !== null &&
            fee.tuition !== undefined &&
            fee.tuition !== -1) ||
          (fee.giftAmount !== null &&
            fee.giftAmount !== undefined &&
            fee.giftAmount !== -1);

        // 只有费用项有效时才添加到可用列表
        if (hasValidAmount) {
          if (fee.levelId) {
            availableLevelIds.add(fee.levelId);
          }
          // 也考虑 type 字段（如 99 技术老师，100 儿童票）
          if (fee.type === 30 || fee.type === 10||fee.type === 70) {
            availableLevelIds.add(fee.type);
          }
        }
      });

      // 过滤身份列表，只保留在费用列表中的身份
      this.identityList = this.allIdentityList.filter(identity => {
        // 检查 level 是否在可用列表中
        const levelOrIdMatch = 
          availableLevelIds.has(identity.level) ||
          availableLevelIds.has(identity.id);
        
        // 特殊处理技术老师和内部员工：根据 userType 匹配费用的 type
        // 技术老师的 userType 是 30，应该匹配费用的 type === 30
        // 内部员工的 userType 是 10，应该匹配费用的 type === 10
        const userTypeMatch = 
          (identity.userType === 30 && availableLevelIds.has(30)) ||
          (identity.userType === 10 && availableLevelIds.has(10));
        
        return levelOrIdMatch || userTypeMatch;
      });
    
      // level=1的数据要和level=2数据报名权限一致
      // 如果结果中有level=2的身份，追加对应的level=1身份
      const level2Identity = this.identityList.find(
        identity => identity.level === 2
      );
      if (level2Identity) {
        // 查找对应的level=1身份（相同id）
        const level1Identity = this.allIdentityList.find(
          identity => identity.level === 1
        );
        // 如果找到且不在结果中，追加到列表后面
        if (
          level1Identity &&
          !this.identityList.find(
            item => item.id === level1Identity.id && item.level === 1
          )
        ) {
          this.identityList.push(level1Identity);
        }
      }
   

      // 如果没有匹配的身份，至少显示所有身份（避免空列表）
      if (this.identityList.length === 0) {
        this.identityList = [...this.allIdentityList];
      }
    },
    // 身份变更 - 根据身份直接获取用户列表
    changeIdentity() {
      // 清空报名人相关信息
      this.form.userId = null;
      this.form.userInfoId = null;
      this.selectOptions = [];
      this.phone = "";
      this.searchVal = "";

      // 清除表单验证状态，避免显示空校验提示
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });

      // 如果没有选择身份，直接返回
      if (!this.form.identityId) {
        return;
      }

      // 根据身份判断对应的用户类型并获取用户列表
      const identity = this.identityList.find(
        item => item.level === this.form.identityId
      );
      if (!identity) {
        return;
      }

      // 根据身份名称和level判断用户类型
      // 技术老师（level 99）-> 技术线（30）
      if (identity.level === 99) {
        this.form.userType = 30;
        this.handleTechnical();
      }
      // 内部员工（level 101）-> 内部员工（10）
      else if(identity.level===101){
        console.log("内部员工",identity);
        this.form.userType = 10;
        this.getUserList();
      }
      // 体验班（level 7）、研修班（level 6）等 -> 客户（20）
      else if ([6, 7].includes(identity.level)) {
        this.form.userType = 20;
        this.getCustomer();
      }
      // 其他身份默认按客户处理
      else {
        this.form.userType = 20;
        this.getCustomer();
      }
    },
    // 格式化身份证显示
    formatIdCard(idCard) {
      if (!idCard) return "";
      if (idCard.length <= 8) return idCard;
      // 显示前3位和后4位，中间用*代替
      const start = idCard.substring(0, 3);
      const end = idCard.substring(idCard.length - 4);
      return `${start}${"*".repeat(idCard.length - 7)}${end}`;
    },
    // 格式化手机号显示
    formatMobile(mobile) {
      if (!mobile) return "";
      if (mobile.length !== 11) return mobile;
      // 显示前3位和后4位，中间用*代替
      const start = mobile.substring(0, 3);
      const end = mobile.substring(mobile.length - 4);
      return `${start}****${end}`;
    },
    // 移除儿童
    removeChild(parentIndex, childIndex) {
      const parent = this.form.registrantList[parentIndex];
      if (parent && parent.child && Array.isArray(parent.child)) {
        parent.child.splice(childIndex, 1);
      }
    },
    // 移除报名人
    removeRegistrant(registrant, index) {
      // 从 registrantList 中移除（同时会移除其所有儿童）
      this.form.registrantList.splice(index, 1);
    },
    // 显示添加儿童弹窗
    showAddChildDialog(parent) {
      this.currentParentRegistrant = parent;
      this.openChildDialog();
    },
    // 打开选择儿童弹窗（组件内部会处理数据加载）
    openChildDialog() {
      this.childDialogVisible = true;
    },
    onChildDialogClose() {
      // 组件关闭时的清理（可选，组件内部已处理）
    },
    // 处理选择儿童确认事件（来自组件）
    handleSelectChildrenConfirm(selectedRows) {
      if (!this.currentParentRegistrant) {
        return;
      }
      const selected = selectedRows || [];
      if (!Array.isArray(this.currentParentRegistrant.child)) {
        this.$set(this.currentParentRegistrant, "child", []);
      }
      const exists = this.currentParentRegistrant.child;
      selected.forEach(item => {
        const dup = exists.find(
          it =>
            it.realName === item.realName &&
            it.mobile === item.mobile &&
            it.idCardNo === item.idCardNo
        );
        if (!dup) {
          exists.push({ ...item });
        }
      });
    },
    // 添加报名人（临时占位，直接向表格新增一行）
    addRegistrant() {
      if (!Array.isArray(this.form.registrantList)) {
        this.$set(this.form, "registrantList", []);
      }
      this.form.registrantList.push({
        realName: "",
        sex: null,
        relationship: "",
        idCardNo: "",
        mobile: "",
        isChild: false
      });
    },
    // 付款凭证上传成功
    handlePayVoucherUpload(response, file, fileList) {
      if (response && response.code === "0") {
        this.payVoucherList.push({
          name: file.name,
          url: response.data
        });
        if (!this.form.payVouchers) {
          this.form.payVouchers = [];
        }
        this.form.payVouchers.push(response.data);
        // 触发验证
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.validateField("payVouchers");
          }
        });
      } else {
        this.$message.error(
          response && response.msg ? response.msg : "上传失败"
        );
      }
    },
    // 付款凭证移除
    handlePayVoucherRemove(file, fileList) {
      const url = file.url || (file.response && file.response.data);
      if (url && this.form.payVouchers) {
        const index = this.form.payVouchers.indexOf(url);
        if (index > -1) {
          this.form.payVouchers.splice(index, 1);
        }
      }
      this.payVoucherList = fileList;
      // 触发验证
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.validateField("payVouchers");
        }
      });
    },
    // 申请凭证上传成功
    handleApplyVoucherUpload(response, file, fileList) {
      if (response && response.code === "0") {
        this.applyVoucherList.push({
          name: file.name,
          url: response.data
        });
        if (!this.form.applyVouchers) {
          this.form.applyVouchers = [];
        }
        this.form.applyVouchers.push(response.data);
      } else {
        this.$message.error(
          response && response.msg ? response.msg : "上传失败"
        );
      }
    },
    // 申请凭证移除
    handleApplyVoucherRemove(file, fileList) {
      const url = file.url || (file.response && file.response.data);
      if (url && this.form.applyVouchers) {
        const index = this.form.applyVouchers.indexOf(url);
        if (index > -1) {
          this.form.applyVouchers.splice(index, 1);
        }
      }
      this.applyVoucherList = fileList;
    },
    changeMeeting() {
      let { meetingId } = this.form;
      // 清空报名人相关字段
      this.form.userId = null;
      this.form.userInfoId = null;
      this.form.userType = null;
      this.form.registrantList = [];
      // 清空选择选项
      this.selectOptions = [];

      // 清除表单验证状态，避免显示空校验提示
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });

      let find = this.options.meetingOptions.find(itt => itt.id === meetingId);
      if (find) {
        // 保存会议详细信息
        this.selectedMeeting = {
          categoryName: find.categoryName || "",
          lecturerRealName: find.lecturerRealName || "",
          startTime: find.startTime || "",
          endTime: find.endTime || "",
          feeList: find.feeList || [], // 保存费用列表用于筛选
          maxCarryPeople: find.maxCarryPeople || null, // 保存最大携带人数
          maxCarryChildPer:
            find.maxCarryChildPer !== undefined ? find.maxCarryChildPer : null // 保存每个报名人最多携带儿童数
        };
        // 设置地址
        let adrs = find.address ? find.address : "";
        this.address = adrs;
        // 根据会议费用列表筛选身份
        this.filterIdentityListByMeeting(find);
        // 清空已选择的身份（因为可选项可能已变化）
        this.form.identityId = null;
      } else {
        // 清空会议信息
        this.selectedMeeting = {};
        this.address = "";
        // 恢复显示所有身份
        this.identityList = [...this.allIdentityList];
        this.form.identityId = null;
      }
    },
    // 格式化会议时间显示
    formatMeetingTime(startTime, endTime) {
      if (!startTime || !endTime) return "";
      const formatDateTime = dateStr => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}.${month}.${day} ${hours}:${minutes}`;
      };
      return `${formatDateTime(startTime)}-${formatDateTime(endTime)}`;
    },
    changeUser() {
      let { userId, userType } = this.form;

      // 如果清空了选择，重置提示语
      if (!userId) {
        this.selectedUserHasFaceInfo = true;
        return;
      }

      let find = this.selectOptions.find(itt => itt.userId === userId);

      // 检查用户是否有人脸认证信息
      if (find) {
        this.selectedUserHasFaceInfo =
          find.faceInfo !== undefined &&
          find.faceInfo !== null &&
          find.faceInfo !== "";
        this.form.userInfoId = userType !== 10 ? find.id : "";
        this.phone = find.phone;
      } else {
        this.selectedUserHasFaceInfo = true; // 如果找不到用户，默认不显示警告
        this.form.userInfoId = "";
        this.phone = "";
      }

      // 切换报名人账号后，清空参会人员数据
      this.form.registrantList = [];
      this.currentParentRegistrant = null;

      // 如果不是 level 6 或 7，自动加载"本人"的报名数据（从后端获取）
      if (!this.canAddMultipleRegistrants && find && this.form.meetingId) {
        this.loadSelfRegistrantData();
      }
    },
    // 加载本人报名数据（从后端获取）
    async loadSelfRegistrantData() {
      if (!this.form.meetingId || !this.form.userId) {
        return;
      }

      try {
        const res = await meetingCarryPeopleApi.list({
          pageNo: 1,
          pageSize: 100,
          isChild: false,
          userId: this.form.userId,
          meetingId: this.form.meetingId,
          userInfoId: this.form.userInfoId,
          userType: this.form.userType
        });

        const list =
          (res &&
            (res.data && res.data.list ? res.data.list : res.data || res)) ||
          [];

        // 查找本人数据（id 为 null 且 relationship 为"本人"）
        const selfData = list.find(
          it => it.id === null && it.relationship === "本人"
        );

        if (selfData) {
          // 构建本人数据
          const selfRegistrant = {
            id: null, // 保持后端返回的 null
            realName: selfData.realName || "",
            sex: selfData.sex || null,
            relationship: "本人",
            idCardNo: selfData.idCardNo || "",
            mobile: selfData.mobile || this.phone || "",
            isChild: false,
            userId: this.form.userId,
            userInfoId: this.form.userInfoId || null,
            userType: this.form.userType || null,
            child: [] // 儿童数组
          };

          // 添加到报名人列表
          if (!Array.isArray(this.form.registrantList)) {
            this.$set(this.form, "registrantList", []);
          }
          // 检查是否已存在本人数据
          const existingSelf = this.form.registrantList.find(
            r => r.id === null && r.relationship === "本人"
          );
          if (!existingSelf) {
            this.form.registrantList.push(selfRegistrant);
          }
        }
      } catch (error) {
        console.error("加载本人报名数据失败:", error);
      }
    },
    changeType() {
      let { userType } = this.form;
      let {
        usersOptions,
        identityOptions,
        customerOptions,
        customerKFOptions
      } = this.options;
      //10 管理员/内部员工 20 客户 21 业务线 30 技术
      if (userType === 10) {
        // if (usersOptions.length > 0) this.selectOptions = usersOptions
        this.getUserList();
      } else if (userType === 20) {
        // if (customerOptions.length > 0) this.selectOptions = customerOptions
        this.getCustomer();
      } else if (userType === 21) {
        // if (customerKFOptions.length > 0) this.selectOptions = customerKFOptions
        this.getKFCustomer();
      } else if (userType === 30) {
        // if (identityOptions.length > 0) this.selectOptions = identityOptions
        this.handleTechnical();
      }
      this.form.userId = null;
    },
    // 搜索用户（远程搜索）
    searchUsers(query) {
      if (query !== "") {
        this.loading = true;
        this.searchVal = query;
        // 根据当前选择的身份和用户类型进行搜索
        if (this.form.userType === 10) {
          this.getUserList();
        } else if (this.form.userType === 20) {
          this.getCustomer();
        } else if (this.form.userType === 21) {
          this.getKFCustomer();
        } else if (this.form.userType === 30) {
          this.handleTechnical();
        } else {
          this.loading = false;
        }
      } else {
        // 如果搜索为空，重新加载初始列表
        this.searchVal = "";
        if (this.form.identityId) {
          this.changeIdentity();
        } else {
          this.selectOptions = [];
          this.loading = false;
        }
      }
    },
    //管理员
    getUserList() {
      this.loading = true;
      userApi
        .fetchListForMini({
          isInternal: 1,
          jobStatus: 1,
          keyword: this.searchVal || ""
        })
        .then(({ data }) => {
          const arr = [];
          data.forEach(it => {
            arr.push({
              value: it.realName || it.userName,
              id: it.id,
              faceInfo: it.faceInfo,
              userId: it.id,
              phone: it.userPho
            });
          });
          this.options.usersOptions = arr;
          this.selectOptions = arr;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleTechnical() {
      this.loading = true;
      //status  10 已入职  20  离职交接  30 已离职
      technicianInfoApi
        .listForMini({ status: 10, keywords: this.searchVal || "" })
        .then(({ data }) => {
          const arr = [];
          // 获取当前选择的身份名称
          const identity = this.identityList.find(
            item => item.level === this.form.identityId
          );
          const identityName = identity ? identity.name : "";
          data.forEach(it => {
            // 过滤掉姓名为 null 或空字符串的项
            if (
              !it.realName ||
              it.realName === "null" ||
              it.realName.trim() === ""
            ) {
              return;
            }
            const phone = it.mobile || "";
            const displayValue = `${it.realName}${
              identityName ? `(${identityName})` : ""
            }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              faceInfo: it.faceInfo,
              userId: it.userId,
              phone: it.mobile
            });
          });
          this.options.identityOptions = arr;
          this.selectOptions = arr;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomer() {
      this.loading = true;
      const params = {
        customerTypes: "3",
        keywords: this.searchVal || ""
      };
      if (this.form.identityId) {
        params.CLevel = this.form.identityId;
      }
      if(params.CLevel<6){
        params.customerTypes = "2";
      }
      customerApi
        .listForMini(params)
        .then(({ data }) => {
          const arr = [];
          // 获取当前选择的身份名称
          const identity = this.identityList.find(
            item => item.level === this.form.identityId
          );
          const identityName = identity ? identity.name : "";
          data.forEach(it => {
            // 过滤掉姓名为 null 或空字符串的项
            if (!it.name || it.name === "null" || it.name.trim() === "") {
              return;
            }
            const phone = it.pho || "";
            const displayValue = `${it.name}${
              identityName ? `(${identityName})` : ""
            }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              faceInfo: it.faceInfo,
              userId: it.userId,
              phone: it.pho
            });
          });
          this.options.customerOptions = arr;
          this.selectOptions = arr;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getKFCustomer() {
      this.loading = true;
      const params = {
        customerTypes: "2",
        name: this.searchVal || ""
      };
      if (this.form.identityId) {
        params.CLevel = this.form.identityId;
      }
      customerApi
        .listForMini(params)
        .then(({ data }) => {
          const arr = [];
          // 获取当前选择的身份名称
          const identity = this.identityList.find(
            item => item.level === this.form.identityId
          );
          const identityName = identity ? identity.name : "";
          data.forEach(it => {
            const phone = it.pho || "";
            const displayValue = `${it.name}${
              identityName ? `(${identityName})` : ""
            }${phone}`;
            arr.push({
              value: displayValue,
              id: it.id,
              faceInfo: it.faceInfo,
              userId: it.userId,
              phone: it.pho
            });
          });
          this.options.customerKFOptions = arr;
          this.selectOptions = arr;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCreate() {
      this.resetForm();
      this.form.carryPeopleList = [
        { realName: "", mobile: "", sex: "", relationship: "" }
      ];
      this.formVisible = true;
      this.getMeeting();
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    onMainDialogClose() {
      // 清空表单与临时状态
      this.resetForm();
      this.payVoucherList = [];
      this.applyVoucherList = [];
      this.registrantCandidates = [];
      this.selectedCandidateRows = [];
      this.selectOptions = [];
      this.form.registrantList = [];
    },
    onSelectDialogClose() {
      // 关闭选择报名人弹窗时清空候选和勾选
      this.registrantCandidates = [];
      this.selectedCandidateRows = [];
    },
    resetForm() {
      this.address = "";
      this.phone = "";
      this.selectedMeeting = {};
      // 恢复显示所有身份
      this.identityList = [...this.allIdentityList];
      for (const key in initFormBean()) {
        this.form[key] = this.old[key];
      }
    },
    getMeeting() {
      // status: 10, statusSub: 23  2025/1/16 测试喊改的
      this.formVisible = true;
      meetingApi
        .fetchList({ status: 10, statusSub: 11, pageSize: 100 })
        .then(data => {
          this.options.meetingOptions = data.data.list || [];
        });
    },
    handleUpdate(row) {
      this.old = { ...row };
      this.resetForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // 验证成人人数限制（不包含本人，总人数 = 本人(1) + maxCarryPeople）
          if (
            this.selectedMeeting &&
            this.selectedMeeting.maxCarryPeople !== null &&
            this.selectedMeeting.maxCarryPeople !== undefined
          ) {
            const registrantList = this.form.registrantList || [];
            const totalAdultCount = registrantList.length;
            const maxTotalAdults = 1 + this.selectedMeeting.maxCarryPeople;

            if (totalAdultCount > maxTotalAdults) {
              this.$message.warning(
                `成人报名人数超过限制，最多只能选择 ${maxTotalAdults} 个成人（包含本人，不包含本人的其他成人最多 ${
                  this.selectedMeeting.maxCarryPeople
                } 个）`
              );
              return;
            }
          }

          // 构建V2接口需要的参数结构
          let params = {
            meetingId: this.form.meetingId,
            userId: this.form.userId,
            userInfoId: this.form.userInfoId || null,
            userType: this.form.userType === 21 ? 20 : this.form.userType,
            carryPeopleList: this.buildCarryPeopleList(),
            payVouchersFee: +this.form.payVouchersFee || 0,
            payVouchersUrls: this.form.payVouchers || [],
            applyVouchersUrl:
              (this.form.applyVouchers && this.form.applyVouchers[0]) || ""
          };

          if (this.isRepSub) return;
          this.isRepSub = true;
          meetingSignUpApi
            .createV2(params)
            .then(data => {
              this.postCallback(data);
            })
            .catch(res => {
              this.isRepSub = false;
              this.$message.error(res.msg || "操作失败");
            });
        }
      });
    },
    // 获取行的样式类名
    getRowClassName({ row }) {
      return row.isChild ? "child-row" : "";
    },
    // 构建携带人员列表
    buildCarryPeopleList() {
      // 从报名人列表构建携带人员列表
      if (
        !this.form.registrantList ||
        !Array.isArray(this.form.registrantList) ||
        this.form.registrantList.length === 0
      ) {
        return [];
      }
      // 处理携带人员数据，确保包含所需字段
      return this.form.registrantList
        .filter(item => item.realName && item.mobile) // 过滤掉空数据
        .map(item => {
          // 构建成人数据
          const parentData = {
            realName: item.realName || "",
            mobile: item.mobile || "",
            sex: item.sex || null,
            relationship: item.relationship || "",
            idCardNo: item.idCardNo || "", // API字段名是idCardNo
            userId: item.userId || null,
            userInfold: item.userInfoId || null, // API字段名是userInfold
            userType: item.userType || null
          };

          // 处理儿童数组
          if (
            item.child &&
            Array.isArray(item.child) &&
            item.child.length > 0
          ) {
            parentData.child = item.child.map(child => ({
              realName: child.realName || "",
              mobile: child.mobile || "",
              sex: child.sex || null,
              relationship: child.relationship || "",
              idCardNo: child.idCardNo || "", // API字段名是idCardNo
              userId: child.userId || null,
              userInfold: child.userInfoId || null, // API字段名是userInfold
              userType: child.userType || null
            }));
          } else {
            parentData.child = null;
          }

          return parentData;
        });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
  background-color: #f8f8f8;
  margin-top: 0 !important; /* 取消默认上边距 */
  top: auto !important; /* 交给 wrapper 居中 */
  .el-dialog__header {
    padding: 6px 40px;
    background-color: #e9f3f7;
    .el-dialog__title {
      color: #4680e3;
      font-size: 14px;
    }
    .el-dialog__headerbtn {
      top: 8px;
    }
  }
  .el-dialog__body {
    padding: 15px 30px;
    max-height: 80vh;
    overflow-y: auto;
  }
}
/* 居中弹窗 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-select {
  width: 100%;
}

.form-section {
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    font-size: 16px;
    color: #000000;
    padding-bottom: 20px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 10px;

    .el-form-item__label {
      color: #666;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .upload-wrapper {
    display: flex;
    align-items: flex-end;
    ::v-deep .el-upload-list {
      .el-upload-list__item {
        width: 40px;
        height: 40px;
        .el-upload-list__item-status-label {
        }
      }
    }
    ::v-deep .el-upload {
      width: 40px;
      height: 40px;
      line-height: 40px;
      .el-icon-plus {
        font-size: 15px;
      }
    }
    .upload-hint {
      color: #666666;
      font-size: 11px;
      padding-left: 4px;
    }
  }
}

.form-row-spacing {
  margin-bottom: 10px;
}

.meeting-info-grid {
  display: flex;
  gap: 10px;
  border-radius: 4px;
  margin-top: 10px;
  padding: 10px 20px;
  flex-wrap: wrap;
  background-color: #f8f8f8;

  .meeting-info-item {
    display: flex;
    line-height: 24px;
    width: calc(50% - 10px);
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    .meeting-info-label {
      color: #666;
      font-size: 14px;
      margin-right: 8px;
      white-space: nowrap;
    }

    .meeting-info-value {
      color: #666;
      font-size: 14px;
    }
  }
}

.gap-22 {
  margin-bottom: 22px !important;
}

.select-registrant-body {
}

/* 报名信息表格样式 - 使用div模拟表格 */
.registrant-table-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.table-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.table-header .table-cell {
  flex: 1;
  padding: 12px 10px;
  text-align: center;
  font-weight: 500;
  color: #606266;
  border-right: 1px solid #ebeef5;
}

.table-header .table-cell:last-child {
  border-right: none;
}

.table-body {
  max-height: 420px;
  overflow-y: auto;
}

.table-row-wrapper {
  border-bottom: 1px solid #ebeef5;
}

.table-row-wrapper:last-child {
  border-bottom: none;
}

.table-row {
  display: flex;
  background-color: #fff;
}

.table-row.parent-row {
  background-color: #fff;
}

.child-rows-wrapper {
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
  border-top: 1px solid #ebeef5;
}
.table-row.child-row {
  display: inline-flex;
  justify-content: flex-end;
  background-color: #e8f5fa;
}

.table-row.child-row .table-cell {
  flex: none;
  padding: 10px 10px 0;
  border-right: none;
}

.table-row .table-cell {
  flex: 1;
  padding: 12px 10px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-row .table-cell:last-child {
  border-right: none;
}

/* 身份证号码列宽度更宽 */
.id-card-cell {
  flex: 1.5;
  min-width: 220px;
}

.child-indent {
  display: inline-block;
  width: 40px;
}

.age-tag {
  color: #999;
  margin-left: 5px;
}

.face-info-warning {
  color: #e73f3f;
  font-size: 11px;
  margin-top: 4px;
}
</style>
